import { Action } from '../../../shared/xs/actions';

export class ClearSelectedStateAssessmentAction implements Action {
  static readonly type = '[Scoreboard] clear current assessment selection';
}
